(function () {
  angular.module("akitabox.ui.dialogs.asset.costLineSelection", [
    "ngMaterial",
    "akitabox.core.services.cancellable",
    "akitabox.core.toast",
    "akitabox.ui.components.input",
    "akitabox.ui.dialogs",
  ]);
})();
